import FileSaver from "file-saver";
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/file`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchFiles = async ({ entity, entityId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${entity}/${entityId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const removeFile = async ({ entity, entityId, fileId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${entity}/${entityId}/${fileId}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const showFile = async ({ entity, entityId, fileId }) => {
  const auth = `Bearer ${getToken()}`;

  const res = await fetch(readUrl(`${entity}/${entityId}/${fileId}`), {
    method: "GET",
    headers: {
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const url = readUrl(`${entity}/${entityId}/${fileId}`);
  const blob = await res.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  // eslint-disable-next-line no-useless-escape
  a.download = url.replace(/^.*[\\\/]/, "");
  a.href = blobUrl;
  document.body.appendChild(a);
  return a;
};
export const downloadFile = async ({ entity, entityId, fileId }) => {
  const auth = `Bearer ${getToken()}`;
  try {
    const res = await fetch(readUrl(`${entity}/${entityId}/${fileId}`), {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    const filename = res.headers.get("Content-Disposition").replace(/^.*filename="(.*)"$/, "$1");
    const blob = await res.blob();

    FileSaver.saveAs(blob, filename);
    return true;
  } catch (error) {
    return { error };
  }
};

export const getSubmotivoFile = async ({ submotivoId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`submotivo/${submotivoId}`), {
    method: "GET",
    headers: {
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchFile = async ({ entity, entityId, fileId, files }) => {
  const auth = `Bearer ${getToken()}`;
  const formData = new FormData();
  Array.from(files).forEach((file) => {
    formData.append("files", file);
  });
  let res = await fetch(readUrl(`${entity}/${entityId}/${fileId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });

  res = await parseJSON(res);

  return res.success;
};
export const uploadFiles = async ({ entity, entityId, files }, options = { newReturn: false, legales: undefined }) => {
  const auth = `Bearer ${getToken()}`;
  const { newReturn = false, legales } = options;
  const formData = new FormData();
  Array.from(files).forEach((file) => {
    formData.append("files", file);
  });
  let res = await fetch(readUrl(`${entity}/${entityId}?newReturn=${!!newReturn}${legales ? `&submotivo=${legales.type}&submotivoId=${legales.id}` : ""}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });

  res = await parseJSON(res);

  return res.success;
};

export const generateZip = async ({ entity, entityId, filesId, fileName }) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`downloadZip`), {
    method: "POST",
    headers: {
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ entity, entityId, filesId, fileName }),
  });

  res = await parseJSON(res);

  return res;
};

export const generateMultiZip = async ({ filesId, fileName }) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`createZipMulti`), {
    method: "POST",
    headers: {
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ filesId, fileName }),
  });

  res = await parseJSON(res);

  return res;
};

export const getProccessStatus = async ({ jobId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`statusZipMulti/${jobId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res;
};

export const dowloadMultiZip = async ({ zipToken }) => {
  const auth = `Bearer ${getToken()}`;

  try {
    const res = await fetch(readUrl(`downloadZipMulti/${zipToken}`), {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) throw new Error("Error al descargar el archivo");

    const contentDisposition = res.headers.get("Content-Disposition");
    let filename = "ordenesDeVenta.zip";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        filename = match[1].replace(/['"]/g, "");
      }
    }

    const blob = await res.blob();
    FileSaver.saveAs(blob, filename);

    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error descargando el ZIP:", error);
    return { error };
  }
};
